module.exports = __webpack_public_path__ + "img/pic2.32b20b44.png";